import { Vue,Component,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import PwdRegisterModal from '@/assets/common/Modal/PwdRegisterModal/PwdRegisterModal.vue'

type SettingForm = {
    sprayDilRatio: boolean;
    sprayDilRatioStartd: string | null;
    pdWhsRecRefOnly: boolean;
    pdChemEdRef: boolean;
    pdLsChemScRef: boolean;
    pdCvhChemRecOnly: boolean;
    pdCvhFertRecOnly: boolean;
};

@Component({
    components: {
        Modal,
        PwdRegisterModal
    }
})
export default class SettingModal extends Vue {

    @Prop()
    isSettingModal!: boolean

    private baseUrl = '/setting_screen';
    private showPwdRegisterModal = false;
    private isLoading = false;
    private savedForm = '';

    form: SettingForm = this.createEmptyForm();

    createEmptyForm(): SettingForm {
        return {
            sprayDilRatio: true,
            sprayDilRatioStartd: null,
            pdWhsRecRefOnly: false,
            pdChemEdRef: false,
            pdLsChemScRef: false,
            pdCvhChemRecOnly: false,
            pdCvhFertRecOnly: false
        };
    }

    @Watch('form.sprayDilRatio')
    onSprayDilRatioChanged(isChecked: boolean): void {
        if (!isChecked) {
            this.form.sprayDilRatioStartd = null;
        }
    }

    @Watch('isSettingModal')
    onModalVisibilityChanged(isOpen: boolean): void {
        this.$emit('update-inert', isOpen);
        if (isOpen) {
            this.getSettingDetails();
        } else {
            this.form = this.createEmptyForm();
        }
    }

    getSettingDetails(){
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
            this.form = res;
            this.savedForm = JSON.stringify(res);
        });
    }

    confirmSetting(): void {
        if (this.isLoading) {
            return;
        }
        if (!window.confirm('内容を上書きして保存します。よろしいですか？')) {
            return;
        }
        const params = {
            ...this.form,
            sprayDilRatioStartd: this.form.sprayDilRatio ? this.form.sprayDilRatioStartd : null
        };
        this.isLoading = true;
        this.$apiClient.doRequest("put", `${this.baseUrl}`, params).then(() => {
            this.getSettingDetails();
            this.$toasted.success('設定を保存しました。');
        }).finally(() => {
            this.isLoading = false;
        });
    }

    cancelSetting(): void {
        if (this.hasChanges && !window.confirm('変更内容を破棄します。よろしいですか？')) {
            return;
        }
        this.getSettingDetails();
    }

    closeModal(): void {
        if (this.hasChanges && !window.confirm('変更内容を破棄します。よろしいですか？')) {
            return;
        }
        this.$emit('update:isSettingModal', false);
    }

    openPwdRegisterModal(): void {
        this.showPwdRegisterModal = true;
    }

    get hasChanges(): boolean {
        return JSON.stringify(this.form) !== this.savedForm;
    }
}
